module.exports = __webpack_public_path__ + "public/files/img/loading-server.4930ab0a.gif";